import { useAppSelector } from "../store/hook";

// The logged-in admin's LoB timezone (code, IANA zone and display label).
export const useLobTimezone = () => useAppSelector((state) => state.lobConfig.timezone);
